import {config, getCookie} from '../helpers';

export function customerFeatureEnabled() {
    try {
        const api = new URL(getCookie('api_url') || config('api.url'));
        return api.origin === 'https://api.fitlap.in' && api.pathname === '/' &&
            !api.username && !api.password && !api.search && !api.hash;
    } catch (_) {
        return false;
    }
}

// Customer destinations remain independent of the selected portal API.
export function customerConfig() {
    if (!customerFeatureEnabled()) return null;
    try {
        const origin = new URL("https://app.fitlap.in/");
        const api = new URL("https://api.fitlap.in/");
        const allowed = url => url.protocol === 'https:' ||
            (url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname));
        if (![origin, api].every(allowed) || origin.username || origin.password ||
            api.username || api.password || origin.pathname !== '/' ||
            origin.search || origin.hash || api.search || api.hash) return null;
        return {origin: origin.origin, apiBaseUrl: api.href.replace(/\/$/, '')};
    } catch (_) {
        return null;
    }
}
